import { dressing } from '@/api'

// const MAINTAINCE_DATA = () => {
// }

const state = {}

const mutations = {}

const getters = {}

const actions = {
  FETCH_DRESSING_READ({}) {
    return dressing.dressingRead().then((data) => {
      return data
    })
  },
  FETCH_DRESSING_IMG_READ({}, filename) {
    return dressing.dressingImgRead(filename)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
}
// export default { actions }
